const EnxFaceAI = require("./components/enxai").default;
module.exports = EnxFaceAI;
